import { render } from "./PersonItem.vue?vue&type=template&id=8971b964&scoped=true"
import script from "./PersonItem.vue?vue&type=script&lang=js"
export * from "./PersonItem.vue?vue&type=script&lang=js"

import "./PersonItem.vue?vue&type=style&index=0&id=8971b964&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8971b964"]])

export default __exports__